import startCase from 'lodash.startcase';
import { fileLoaderURL } from '../utils/endpoints';
import FileLoaderSDK from '@nackle/file-loader-sdk';

function FileLoaderService( { access_token } ) {
    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };

    return new FileLoaderSDK( fileLoaderURL, fetchWithAuth );
}

export default FileLoaderService;

export const { statuses, triggerTypes, extractTypes, extractStatuses } = FileLoaderSDK;

let _fileParameters = null;

export const setFileParameters = ( fileParameters ) => {
    _fileParameters = fileParameters;
};

export const getFileParameters = () => {
    return _fileParameters;
};

export const clearFileParameters = () => {
    _fileParameters = null;
};

export const getFileStatusText = ( file ) => {
    // show validating when staging
    if (
        file.status === statuses.SHARED_STAGING ||
        file.status === statuses.LOADER_STAGING
    ) {
        return 'Validating';
    }
    // show validated when staged
    if (
        file.status === statuses.SCHEMA_VALIDATED ||
        file.status === statuses.SHARED_STAGED ||
        file.status === statuses.LOADER_STAGED
    ) {
        if ( file.sharedStagingCompletedAt && !file.loaderStagingCompletedAt ) {
            return 'Validating';
        }
        if ( !file.loaderStagingCompletedAt ) {
            return startCase( ( file.status || '' ).toLowerCase() );
        }

        // check that the validation happened within 24 hours
        const createdTimeFrame = 1000 * 60 * 60 * 24; // 24 hours
        const created = new Date( Date.now() - createdTimeFrame );
        if ( new Date( file.loaderStagingCompletedAt ).valueOf() < created.valueOf() ) {
            return 'Needs Re-Validation';
        }

        if ( file.totalErrorCount !== 0 ) {
            return 'Validated with Errors';
        }

        return 'Validated';
    }

    // show validation or loading failed
    if ( file.status === statuses.FAILED ) {
        if ( file.loadingStartedAt ) {
            return 'Loading Failed';
        } else if (
            file.sharedStagingStartedAt &&
            file.totalFileRecordValidatdCount < file.totalFileRecordCount
        ) {
            return 'Validating';
        } else {
            return 'Validation Failed';
        }
    }

    if ( file.status === statuses.LOADED && file.totalErrorCount > 0 ) {
        return 'Loaded with Errors';
    }

    return startCase( ( file.status || '' ).toLowerCase() );
};

export const getNeedsChecking = ( file ) => {
    if ( !file ) {
        return false;
    }
    if ( file.status === statuses.FAILED ) {
        return (
            file.sharedStagingStartedAt &&
            file.totalFileRecordValidatedCount < file.totalFileRecordCount
        );
    }
    return (
        file.status !== statuses.LOADER_STAGED &&
        file.status !== statuses.LOADED
    );
};